import styled from 'styled-components';
import { TYPOGRAPHY, COLOR } from '../../theme/constants';
import { FlexContainer } from '@emarketer/componentlibrary';

export const TemplateContainer = styled.div`
  min-height: 90vh;
`;

export const TemplateTabHeaderWrapper = styled(FlexContainer)`
  border-bottom: 1px solid ${COLOR.GRAY200};

  @media (max-width: 1200px) {
    overflow-x: auto;
  }
`;

export const TemplateTab = styled.div<{ tabKey: string; active?: boolean; premium?: boolean }>`
  cursor: pointer;
  font-size: 16px;
  color: ${COLOR.DARKGREY2};
  position: relative;
  padding: 4px 0;
  white-space: nowrap;

  ${(p) => (p.premium === false ? `margin-top: 16px;` : ``)}

  ${TYPOGRAPHY.BOLD};
  ${(p) =>
    p.active
      ? `
    color: black;
    &::after {
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: ${COLOR.BLUE};
      content: "";

      @media (max-width: 1200px) {
        bottom: 0;
      }
    }
  `
      : ''}
`;

export const PremiumWrapper = styled(FlexContainer)``;

export const PremiumTabText = styled.p`
  margin: 0px;
`;

export const TemplateTabWrapper = styled.div``;

export const TemplateTabContent = styled.div`
  margin: 32px 0;
`;
